import { Directive } from '@angular/core';
@Directive({
  selector: '[fSelectorContainer]'
})
export class SelectorContainerDirective {}
